import type { FC } from 'react'
import { StructuredText } from 'react-datocms'
import styled from 'styled-components'

import type { SciencePageStudiesGroupRecord } from '@/graphql/OurStudies'

import { SciencePageStudyBlock } from '@/components/blocks/SciencePageStudyBlock'
import { Container } from '@/components/shared/Container'

const StyledContentContainer = styled.div`
  text-align: center;

  h2 {
    font-size: ${(p) => p.theme.v2.typography.display.xxs.fontSize};
    line-height: ${(p) => p.theme.v2.typography.display.xxs.lineHeight};
    font-family: ${(p) => p.theme.v2.font.nantes};
    color: ${(props) => props.theme.v2.onSurface.text};
    margin-bottom: 60px;
    margin-top: 80px;

    @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
      font-size: ${(p) => p.theme.v2.typography.body.xl.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.xl.lineHeight};
      margin-top: 48px;
      margin-bottom: 32px;
    }
  }
`

const StyledStudiesContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 32px;
  margin-bottom: 46px;

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
  }
`

export const SciencePageStudiesGroupBlock: FC<{ record: SciencePageStudiesGroupRecord }> = ({ record }) => {
  return (
    <Container id={record.id}>
      <StyledContentContainer>
        <StructuredText data={record.content} />
      </StyledContentContainer>

      <StyledStudiesContainer>
        {record.studiesList.map((study) => (
          <SciencePageStudyBlock record={study} key={study.id} />
        ))}
      </StyledStudiesContainer>
    </Container>
  )
}
